<template>
  <div class="mk-connector-object"  @click="clickCallback">
    <div
      class="mk-button mk-connector-object__dummy"
      :class="isStandApproved() ? '': 'mk-connector-object__dummy--error'"
    >
      <span>{{object.title}}</span>
      <span class="mk-connector-object__subtitle">{{valueInMetric}}{{metric ? 'mm' : '\"'}}</span>
    </div>
  </div>
</template>

<script>
/**
 * Selection Stand Object
 * @author David <david.prenninger@gmx.de>
 *
 * This component represents a Stand as part of the configuration.
 * It shows title and values and runs a callback when clicked.
 */
export default {
  props: {
    object: Object,
    clickCallback: Function,
    index: Number,
    standApproval: Array,
  },
  computed: {
    metric() {
      return this.$store.getters.metric;
    },
    valueInMetric() {
      if (this.metric) {
        return Math.floor(this.object.length * 500);
      }
      return Number(((this.object.length * 500) / 25.4).toFixed(1));
    },
  },
  methods: {
    isStandApproved() {
      const standApproval = this.standApproval[this.index];
      if (
        standApproval
        && standApproval.stand
        && standApproval.stand.distanceBack > this.object.length / 2 - 0.01
        && standApproval.stand.distanceFront > this.object.length / 2 - 0.01
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-connector-object {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 4px;

  &__dummy {
    border-top-left-radius: $br_md;
    border-top-right-radius: $br_md;
    width: 40px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    color: $c_white;
    background-color: $c_glass;
    align-items: center;
    font-size: 14px;

    &--error {
      border: 2px solid $c_warning;
    }
  }

  &__subtitle {
    font-size: 12px;
  }
}
</style>
